function wire(key){
  const back=SGID('back');
  if(back) back.onclick=()=>{if(S.step>0){S.step--;render();}};
  const next=SGID('next');
  if(next) next.onclick=()=>validateAndNext(key);

  if(key==='id'){
    SGID('lookup').onclick=()=>{
      const ord=SGID('ord').value.trim();
      const mail=SGID('mail').value.trim();
      if(!validEmail(mail)){showErr('e_id');invalid(['mail']);return;}
      const root=document.querySelector('#sav-root');const ep=(root&&root.dataset&&root.dataset.endpoint)||'';
      const btn=SGID('lookup');const eid=SGID('e_id');
      if(ep){
        btn.disabled=true;btn.textContent='Recherche…';
        fetch(ep,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({order:ord,email:mail})})
          .then(r=>r.json()).then(d=>{
            btn.disabled=false;btn.textContent='Retrouver ma commande';
            if(d&&d.found&&d.products&&d.products.length){S.order={id:d.id||ord,date:d.date||'',email:mail,products:d.products};S.noOrder=false;S.contact.email=mail;render();}
            else{if(eid){eid.textContent="Commande introuvable avec ce numéro et cet email. Vérifie, ou clique « Je n'ai pas mon numéro ».";eid.style.display='block';}}
          }).catch(()=>{btn.disabled=false;btn.textContent='Retrouver ma commande';if(eid){eid.textContent="Vérification indisponible pour le moment. Tu peux continuer sans numéro.";eid.style.display='block';}});
        return;
      }
      const o=JSON.parse(JSON.stringify(MOCK_ORDER));o.id=ord||MOCK_ORDER.id;o.email=mail;
      S.order=o;S.noOrder=false;S.contact.email=mail;render();
    };
    SGID('skip').onclick=()=>{S.noOrder=true;S.order=null;S.step++;render();};
  }
  if(key==='motif'){app.querySelectorAll('.opt').forEach(el=>clickable(el,()=>{S.motif=el.dataset.k;S.selProducts=[];S.famille=null;S.answers={};render();}));}
  if(key==='product'){app.querySelectorAll('.prod').forEach(el=>clickable(el,()=>{const i=+el.dataset.i;if(S.selProducts.includes(i))S.selProducts=S.selProducts.filter(x=>x!==i);else S.selProducts.push(i);S.famille=null;render();}));}
  if(key==='famille'){app.querySelectorAll('.opt').forEach(el=>clickable(el,()=>{S.famille=el.dataset.f;render();}));}
  if(key==='diag'){const sv=SGID('solved');if(sv)sv.onclick=()=>{app.innerHTML=`<div class="done"><div class="big">✓</div><h2 class="q">Super, ravi que ce soit réglé&nbsp;!</h2><p class="sub">Aucun ticket créé.</p><button class="btn ghost" id="restart">↻ Refaire une démo</button></div>`;SGID('restart').onclick=reset;};}
  if(key==='photo'){
    const drop=SGID('drop');const inp=SGID('fileinput');
    clickable(drop,()=>inp.click());
    inp.onchange=()=>{addFiles(inp.files);inp.value='';};
    drop.ondragover=e=>{e.preventDefault();drop.classList.add('drag');};
    drop.ondragleave=()=>drop.classList.remove('drag');
    drop.ondrop=e=>{e.preventDefault();drop.classList.remove('drag');addFiles(e.dataTransfer.files);};
    paintFiles();
  }
  if(key==='solution'){app.querySelectorAll('.opt').forEach(el=>clickable(el,()=>{S.solution=el.dataset.sol;render();}));}
  if(key==='recap'){
    SGID('send').onclick=()=>{app.innerHTML=VIEWS.done();bar.style.width='100%';SGID('restart').onclick=reset;};
    const cp=SGID('copy');
    if(cp) cp.onclick=()=>{
      const t=buildMessage().join(String.fromCharCode(10,10));
      const ta=document.createElement('textarea');ta.value=t;ta.style.position='fixed';ta.style.opacity='0';
      document.body.appendChild(ta);ta.focus();ta.select();
      try{document.execCommand('copy');}catch(e){}
      document.body.removeChild(ta);
      cp.textContent='Copié !';setTimeout(()=>cp.textContent='Copier le message',1500);
    };
  }
}

function addFiles(list){
  [...list].forEach(f=>{
    const item={name:f.name,thumb:null};
    S.files.push(item);
    if(f.type&&f.type.indexOf('image')===0){const r=new FileReader();r.onload=e=>{item.thumb=e.target.result;paintFiles();};r.readAsDataURL(f);}
  });
  paintFiles();
}
function paintFiles(){
  const fl=SGID('filelist');if(!fl)return;
  if(!S.files.length){fl.innerHTML='';return;}
  fl.innerHTML=S.files.map((f,i)=>{
    const media=f.thumb?`<img src="${f.thumb}" alt="">`:'<div class="ph"></div>';
    return `<div class="thumb-item">${media}<button class="rm" data-x="${i}" title="Retirer">✕</button><div class="fname">${esc(f.name||'fichier')}</div></div>`;
  }).join('');
  fl.querySelectorAll('.rm').forEach(b=>b.onclick=()=>{S.files.splice(+b.dataset.x,1);paintFiles();});
}
function showErr(id){const e=SGID(id);if(e)e.style.display='block';}
function clickable(el,fn){if(!el)return;el.onclick=fn;el.tabIndex=0;el.setAttribute('role','button');el.onkeydown=e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();fn();}};}
function validEmail(v){return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((v||'').trim());}
function clearInval(){app.querySelectorAll('.inval').forEach(e=>e.classList.remove('inval'));}
function invalid(ids){const els=ids.map(id=>SGID(id)).filter(Boolean);els.forEach(e=>e.classList.add('inval'));if(els[0]){els[0].focus();if(els[0].scrollIntoView)els[0].scrollIntoView({block:'center',behavior:'smooth'});}}
function wireEnter(){app.querySelectorAll('input[type=text],input[type=email],input[type=tel]').forEach(i=>{i.onkeydown=e=>{if(e.key==='Enter'){e.preventDefault();const lk=SGID('lookup');const nb=SGID('next');if(lk)lk.click();else if(nb)nb.click();}};});}

function collectDiag(){
  const ids=['when'].concat(FAMILLES[S.famille].q.map(q=>q.id)).concat(['desc']);
  ids.forEach(id=>{const el=SGID('f_'+id);if(el)S.answers[id]=el.value.trim();});
}
function collect(key){
  const g=id=>{const el=SGID(id);return el?el.value.trim():'';};
  const gf=id=>{const el=SGID('f_'+id);return el?el.value.trim():'';};
  if(key==='product'&&(S.noOrder||!S.order)) S.answers.pfree=g('pfree');
  if(key==='diag') collectDiag();
  if(key==='q_casse'){S.answers.recdate=gf('recdate');S.answers.pack=gf('pack');S.answers.desc=gf('desc');}
  if(key==='q_erreur'){S.answers.got=gf('got');S.answers.refgot=gf('refgot');}
  if(key==='q_manquant'){S.answers.desc=gf('desc');S.answers.sealed=gf('sealed');}
  if(key==='q_retract'){S.answers.used=gf('used');S.answers.desc=gf('desc');}
  if(key==='q_garantie'){S.answers.desc=gf('desc');}
  if(key==='contact'){S.contact.nom=g('nom');S.contact.email=g('cmail');S.contact.tel=g('tel');}
}

function validateAndNext(key){
  collect(key);clearInval();
  if(key==='id'&&!(S.order||S.noOrder)){showErr('e_id');return;}
  if(key==='motif'&&!S.motif){showErr('e_motif');return;}
  if(key==='product'){
    if((S.noOrder||!S.order)&&!S.answers.pfree){showErr('e_prod');invalid(['pfree']);return;}
    if(!(S.noOrder||!S.order)&&S.selProducts.length===0){showErr('e_prod');return;}
  }
  if(key==='famille'&&!S.famille){showErr('e_fam');return;}
  if(key==='diag'){
    const miss=[];if(!S.answers.when)miss.push('f_when');
    FAMILLES[S.famille].q.filter(q=>q.req).forEach(q=>{if(!S.answers[q.id])miss.push('f_'+q.id);});
    if(miss.length){showErr('e_q');invalid(miss);return;}
  }
  if(key==='q_casse'){const miss=[];if(!S.answers.recdate)miss.push('f_recdate');if(!S.answers.pack)miss.push('f_pack');if(!S.answers.desc)miss.push('f_desc');if(miss.length){showErr('e_q');invalid(miss);return;}}
  if(key==='q_erreur'&&!S.answers.got){showErr('e_q');invalid(['f_got']);return;}
  if(key==='q_manquant'&&!S.answers.desc){showErr('e_q');invalid(['f_desc']);return;}
  if(key==='q_retract'&&!S.answers.used){showErr('e_q');invalid(['f_used']);return;}
  if(key==='q_garantie'&&!S.answers.desc){showErr('e_q');invalid(['f_desc']);return;}
  if(key==='photo'){const req=(S.motif==='defaut'||S.motif==='casse'||S.motif==='erreur');if(req&&S.files.length===0){showErr('e_photo');return;}}
  if(key==='solution'&&!S.solution){showErr('e_sol');return;}
  if(key==='contact'){const miss=[];if(!S.contact.nom)miss.push('nom');if(!validEmail(S.contact.email))miss.push('cmail');if(miss.length){showErr('e_ct');invalid(miss);return;}}
  S.step++;render();
}

function reset(){S.step=0;S.order=null;S.noOrder=false;S.motif=null;S.selProducts=[];S.famille=null;S.answers={};S.files=[];S.solution=null;S.contact={nom:'',email:'',tel:''};render();}

function savResize(){var h=document.documentElement.scrollHeight;try{if(window.frameElement)window.frameElement.style.height=h+'px';}catch(e){}try{parent.postMessage({savHeight:h},'*');}catch(e){}}
new MutationObserver(savResize).observe(document.body,{subtree:true,childList:true,attributes:true});window.addEventListener('load',savResize);setTimeout(savResize,300);
render();
